import {BrowserModule} from '@angular/platform-browser';
import {Injector, NgModule} from '@angular/core';
import {ServiceLocator} from '../services/locator.service';

/***    ANGULAR MATERIAL IMPORT    ***/
// animations

// components
import {
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatToolbarModule,
    MatTableModule,
    MatCardModule,
    MatTooltipModule,
    MatPaginatorModule, MatProgressBarModule, MatDialogModule, MatExpansionModule, MatFormFieldModule,
    MatInputModule, MatSlideToggleModule, MatSortModule, MatTabsModule, MatAutocompleteModule, MatRadioModule, MatDatepickerModule,
    MatSelect, MatSelectModule, MatMenuTrigger, MatCheckboxModule, MatProgressSpinnerModule,
} from '@angular/material';
/***    ANGULAR MATERIAL IMPORT    ***/

import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PipesModule} from '../pipes/pipes.module';
import {NgbTimepickerModule} from '@ng-bootstrap/ng-bootstrap';
import {DatetimeTermpickerComponent} from '../SharedModule/DatetimeTermpickerComponent/datetime-termpicker.component';
import {SharedModule} from '../SharedModule/shared.module';
import {MomentModule} from 'angular2-moment';
import {EditorModule} from '@tinymce/tinymce-angular';
import {DirectivesModule} from '../directives/directives.module';
import {DragulaModule} from 'ng2-dragula';
import {DocumentListComponent} from './DocumentListComponent/document-list.component';
import {DocumentEditComponent} from './DocumentEditComponent/document-edit.component';
import {DocumentService} from '../services/document.service';
import {DocumentTypeService} from '../services/document-type.service';
import {DocumentCreateDialogComponent} from './DocumentCreateDialogComponent/document-create.dialog.component';
import {DocumentCompanyService} from '../services/document-company.service';
import {CustomerService} from '../services/customer.service';
import {PaymentTypeService} from '../services/payment-type.service';
import {DocumentLiquidationsDialogComponent} from './DocumentLiquidationsDialogComponent/document-liquidations.dialog.component';
import {VatService} from '../services/vat.service';
import {DocumentLiquidationService} from '../services/documentLiquidation.service';
import {ProductService} from '../services/product.service';
import {DocumentLinkDialogComponent} from './DocumentLinkDialogComponent/document-link.dialog.component';
import {DocumentLinkService} from '../services/document-link.service';
import {DocumentPohodaDialogComponent} from './DocumentPohodaDialogComponent/document-pohoda.dialog.component';
import {PohodaService} from '../services/pohoda.service';
import {DocumentDeleteDialogComponent} from './DocumentDeleteDialogComponent/document-delete.dialog.component';
import {
    DocumentConfirmDeleteLiquidationsDialogComponent
} from './DocumentConfirmDeleteLiquidationsDialogComponent/document-confirm-delete-liquidations.dialog.component';
import {DocumentMailDialogComponent} from './DocumentMailDialogComponent/document-mail.dialog.component';
import {DocumentCurrencyService} from '../services/document-currency.service';
import {DocumentPaymentsUploadDialogComponent} from './DocumentPaymentsUploadDialogComponent/document-payments-upload.dialog.component';
import {DocumentPaymentsResultsDialogComponent} from './DocumentPaymentsResultsDialogComponent/document-payments-results.dialog.component';
import {PaymentService} from '../services/payment.service';
import {DocumentExportDialogComponent} from './DocumentExportDialogComponent/document-export.dialog.component';
import {CustomerCreateDialogComponent} from '../CustomersModule/CustomerCreateDialogComponent/customer-create.dialog.component';
import {AresService} from '../services/ares.service';


@NgModule({
    declarations: [
        DocumentListComponent,
        DocumentEditComponent,
        DocumentCreateDialogComponent,
        DocumentLinkDialogComponent,
        DocumentDeleteDialogComponent,
        DocumentConfirmDeleteLiquidationsDialogComponent,
        DocumentLiquidationsDialogComponent,
        DocumentMailDialogComponent,
        DocumentPohodaDialogComponent,
        DocumentPaymentsUploadDialogComponent,
        DocumentPaymentsResultsDialogComponent,
        DocumentExportDialogComponent,
        CustomerCreateDialogComponent,
    ],
    imports: [
        BrowserModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        EditorModule,
        DirectivesModule,
        DragulaModule,

        // Angular Material components
        MatAutocompleteModule,
        MatButtonModule,
        MatCardModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatDialogModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatSortModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        NgbTimepickerModule,
        MomentModule,
        PipesModule,
        SharedModule
    ],
    exports: [
        DocumentListComponent
    ],
    entryComponents: [
        DocumentListComponent,
        DocumentEditComponent,
        DocumentCreateDialogComponent,
        DocumentLinkDialogComponent,
        DocumentConfirmDeleteLiquidationsDialogComponent,
        DocumentLiquidationsDialogComponent,
        DocumentDeleteDialogComponent,
        DocumentMailDialogComponent,
        DocumentPohodaDialogComponent,
        DocumentPaymentsUploadDialogComponent,
        DocumentPaymentsResultsDialogComponent,
        DocumentExportDialogComponent,
        CustomerCreateDialogComponent,
    ],
    providers: [
        DocumentService,
        DocumentTypeService,
        DocumentLinkService,
        DocumentCurrencyService,
        DocumentCompanyService,
        PohodaService,
        CustomerService,
        ProductService,
        PaymentTypeService,
        DocumentLiquidationService,
        VatService,
        PaymentService,
        AresService,
    ]
})
export class DocumentsModule {

    constructor(private injector: Injector) {  // Create global Service Injector.
        ServiceLocator.injector = this.injector;
    }
}



// WEBPACK FOOTER //
// /app/src/DocumentsModule/documents.module.ts